export const truncateText = (text: string, length: number, indicator = '...'): string =>
  text.length > length ? text.slice(0, length) + indicator : text;

export const replaceGuidsToMock = (input: string): string => {
  const guidPattern = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}/g;
  return input.replace(guidPattern, '<guid>');
};
